import { apiRequest } from '@/utils/api-request';

export function buildSearchQueryExportUrl(args: {
  orgId: string;
  collectionId: string;
  from: string;
  to: string;
}): string {
  const params = new URLSearchParams({
    from: args.from,
    to: args.to,
    collection_id: args.collectionId,
  });
  return `/${encodeURIComponent(args.orgId)}/external-search/queries?${params.toString()}`;
}

export async function fetchSearchQueryCsv(args: {
  orgId: string;
  collectionId: string;
  from: string;
  to: string;
}): Promise<{ data?: string; detail?: string }> {
  const response = await apiRequest<string>({
    url: buildSearchQueryExportUrl(args),
    method: 'GET',
    target: 'platform',
    responseType: 'text',
  });

  if (response.detail || typeof response.data !== 'string') {
    return { detail: response.detail || 'Could not download search queries' };
  }

  return { data: response.data };
}
